export const INVE_FIELDS = {
  INVE0_investorNo: 'INVE0',
  INVE1_language: 'INVE1',
  INVE2_lastName: 'INVE2',
  INVE3_firstName: 'INVE3',
  INVE4_socialSecurityNumber: 'INVE4',
  INVE5_occupation: 'INVE5',
  INVE6_gender: 'INVE6',
  INVE7_address: 'INVE7',
  INVE8_appNumber: 'INVE8',
  INVE9_city: 'INVE9',
  INVE10_countryCode: 'INVE10',
  INVE11_provinceCode: 'INVE11',
  INVE12_postalCode: 'INVE12',
  INVE13_phone: 'INVE13',
  INVE14_birthdate: 'INVE14',
  INVE15_email: 'INVE15',
  INVE16_accountNo: 'INVE16',
  INVE17_accountType: 'INVE17',
  INVE18_productType: 'INVE18',
  INVE19_guarantee: 'INVE19',
  INVE20_spouseLastName: 'INVE20',
  INVE21_spouseFirstName: 'INVE21',
  INVE22_spouseOccupation: 'INVE22',
  INVE23_spouseGender: 'INVE23',
  INVE24_spouseAddress: 'INVE24',
  INVE25_spouseAppNumber: 'INVE25',
  INVE26_spouseCity: 'INVE26',
  INVE27_spouseCountryCode: 'INVE27',
  INVE28_spouseProvinceCode: 'INVE28',
  INVE29_spousePostalCode: 'INVE29',
  INVE30_spousePhone: 'INVE30',
  INVE31_spouseBirthdate: 'INVE31',
  INVE32_spouseEmail: 'INVE32',
  INVE33_spouseLanguage: 'INVE33',
  INVE34_bankAccountBankNo: 'INVE34',
  INVE35_bankAccountTransit: 'INVE35',
  INVE36_bankAccountFolio: 'INVE36',
  INVE37_bankAccountMasked: 'INVE37',
  INVE38_bankAccountBankName: 'INVE38',
  INVE39_bankAccountHolder: 'INVE39',
  INVE42_existingAccountsCount: 'INVE42',
  INVE43_existingAccountNo: 'INVE43',
  INVE44_existingAccountProductType: 'INVE44',
  INVE45_existingAccountPlan: 'INVE45',
  INVE46_existingAccountGuarantee: 'INVE46',
  INVE40_existingAccountSpousalFlag: 'INVE40',
  INVE41_existingAccountFab: 'INVE41',
  INVE47_existingAccountPurchaserMemberContractHolder: 'INVE47',
  INVE_IsPrefilledClient: 'INVE_isprefilledclient',
} as const;
